let isHandlingUnauthorized = false;

export const getAuthToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage.getItem("authToken");
};

export const clearAuthSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem("authToken");
  window.localStorage.removeItem("authUser");

  window.dispatchEvent(new Event("eveness-auth-changed"));
};

export const handleUnauthorized = (failedToken) => {
  if (typeof window === "undefined") {
    return false;
  }

  const currentToken = getAuthToken();

  if (!currentToken) {
    return false;
  }

  if (failedToken && failedToken !== currentToken) {
    return false;
  }

  if (isHandlingUnauthorized) {
    return true;
  }

  isHandlingUnauthorized = true;

  clearAuthSession();

  window.location.replace("/");

  return true;
};
